import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getCountriesRequest } from "lib/api/reference/country";
import type { CountryInterface } from "types/reference";

export const countryReferenceKeys = {
    all: ["reference", "country"] as const,
    list: (languageCode: string) => [...countryReferenceKeys.all, "list", languageCode] as const,
};

export const fetchCountries = (languageCode: string) =>
    parseResponse<Array<CountryInterface>>(getCountriesRequest(languageCode));

export const countryReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<CountryInterface>>({
        queryKey: countryReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchCountries(languageCode),
        enabled: Boolean(languageCode),
    });

export const useCountries = (languageCode: string) => useQuery(countryReferenceQueryOptions(languageCode));
